var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"Ramucirumab"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(item.approvedIndicationsDrug)+" ")]),_c('div',{staticClass:"show-box"}),_c('RamContent',{attrs:{"text":item.approvedIndications}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }